import React from 'react';
import { Navigate } from 'react-router-dom';
import { AUTH_TOKEN_KEY } from '../utils/constants';
import LoadingSpinner from './common/LoadingSpinner';
import { useUser } from '../context/UserContext';

const ProtectedRoute = ({ children }) => {
  const { loading } = useUser();
  const token = localStorage.getItem(AUTH_TOKEN_KEY);

  if (loading) {
    return <LoadingSpinner message="Loading..." />;
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;